'use client'

import {usePathname} from 'next/navigation'
import {HgButton, HgButtonLink} from '~/design-system/hg/components'
import {copyToClipboard} from '~/design-system/utils/copyToClipboard'

export function HgArticleShareLinkContent({title}: {title: string}) {
  const pathname = usePathname()

  const baseUrl = 'https://mercury.com'
  const fullUrl = `${baseUrl}${pathname}`

  const getTwitterLink = (): string => {
    const domain = 'https://twitter.com/'
    const connector = 'intent/tweet?text='
    const encodedTitle = encodeURI(title)

    return `${domain}${connector}${encodedTitle}%20${fullUrl}`
  }

  const getLinkedInLink = (): string => {
    const domain = 'https://linkedin.com/'
    const connector = 'sharing/share-offsite/?url='

    return `${domain}${connector}${fullUrl}`
  }

  const getFacebookLink = (): string => {
    const domain = 'https://facebook.com/'
    const connector = 'sharer/sharer.php?u='

    return `${domain}${connector}${fullUrl}`
  }
  return (
    <div className="flex flex-row flex-wrap gap-s1">
      <HgButton
        contentType="icon"
        variant="text"
        iconProps={{iconType: 'link'}}
        aria-label="copy link"
        onClick={async () => await copyToClipboard(fullUrl)}
        tooltip="Copy link"
      />
      <HgButtonLink
        contentType="icon"
        variant="text"
        iconProps={{iconType: 'facebook'}}
        aria-label="facebook share"
        href={getFacebookLink()}
        tooltip="Share on Facebook"
        data-analytics-event-name="blog-article-facebook-share"
        newTab
      />
      <HgButtonLink
        contentType="icon"
        variant="text"
        iconProps={{iconType: 'linkedin'}}
        aria-label="linkedin share"
        href={getLinkedInLink()}
        tooltip="Share on LinkedIn"
        data-analytics-event-name="blog-article-linkedin-share"
        newTab
      />
      <HgButtonLink
        contentType="icon"
        variant="text"
        iconProps={{iconType: 'x-twitter'}}
        aria-label="x/twitter share"
        tooltip="Share on X"
        href={getTwitterLink()}
        data-analytics-event-name="blog-article-x-twitter-share"
        newTab
      />
    </div>
  )
}

const HgArticleShareLinks = ({title}: {title: string}) => {
  return (
    <div className="flex flex-col gap-s3 border-t border-border-frosted">
      <p className="pt-s3 arcadia-heading-9">Share article</p>
      <HgArticleShareLinkContent title={title} />
    </div>
  )
}

export default HgArticleShareLinks
